export default {
  title: 'Balance Sheet Assets',
  subTitle: 'Lorem ipsum dolor',
  addNewOwnOperation: 'Add New Own Operation',
  createNewOwnOperation: 'Create New Own Operation',
  editOwnOperation: 'Edit Own Operation',
  addNewBalanceSheetAsset: 'Add New Balance Sheet Asset',
  createNewBalanceSheetAsset: 'Create New Balance Sheet Asset',
  editBalanceSheetAsset: 'Edit Balance Sheet Asset',
  fields: {
    details: 'Details',
    orgPath: 'Org Structure',
    name: 'Asset Name',
    uniqueIdentifier: 'Asset System Unique Identifier',
    legalEntity: 'Legal Entity Name',
    profitCentreID: 'Profit Centre (select lowest Profit Centres only)',
    profitCentre: 'Profit Centre',
    valueChain: 'Value Chain Position',
    ownership: 'Ownership',
    equityShareholding: 'Equity Shareholding %',
    financialControl: 'Financial Control %',
    physicalOrLogical: 'Physical or Logical',
    assetCategory: 'Asset Category',
    owned: 'Owned/Leased',
    employees: 'No. of Employees',
    dateOpened: 'Date Opened',
    dateClosed: 'Date Closed',
    industry: 'Industry (NACE)',
    sector: 'Sector (NACE)',
    taxonomy: 'EU Taxonomy Activity Code',
    netBook: 'Net Book Value',
    country: 'Country of Operation / Incorporation',
    state: 'State / Region / County',
    post: 'Post Code',
    town: 'City',
    street: 'Street',
    building: 'Building Name / Number',
    coordinates: 'Coordinates',
    actions: 'Actions',
    startDate: 'FY Start Date',
    endDate: 'FY End Date',
  },
  filter: {
    resetFilters: 'Reset Filters',
    menu: {
      organizational: 'Organizational',
      geographical: 'Geographical',
    },
  },
  selections: {
    general: 'General',
    details: 'Details',
    financials: 'Financials',
    address: 'Address',
  },
};
